import { render, staticRenderFns } from "./ChatTnC.vue?vue&type=template&id=06bf4d65&scoped=true"
import script from "./ChatTnC.vue?vue&type=script&lang=js"
export * from "./ChatTnC.vue?vue&type=script&lang=js"
import style0 from "./ChatTnC.vue?vue&type=style&index=0&id=06bf4d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf4d65",
  null
  
)

export default component.exports